import { useContext, useEffect, useState } from "react"
import { 
    SideBarLabel,
    SideBarIcons, 
} from './style'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import './style.scss'
import { GridContainer, NavigationMenu } from "src/style"
import { useLocation } from "react-router-dom"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

//const disabledMenu = ['Borrow', 'Insight', 'Lifestyle']

export const SidebarMenu: React.FC<any> = ({item}) => {
    const location = useLocation()
    const {showSideBar} = useContext(VisibilityContext)
    const [isDisabled, setIsDisabled] = useState('')
    const [isHover, setIsHover] = useState(false)
    const {setInfoProperty} = useContext(AppInfoContext)

    // useEffect(() => {
    //     if (disabledMenu.includes(item?.title)) {
    //         setIsDisabled('disabled')
    //     }
    // }, [])

    useEffect(() => {
        if (item.path.includes(location.pathname)) {
            setIsHover(true)
        }
        else setIsHover(false)
    }, [location.pathname])

    const handleSideBarShow = async (e: any) => {
        if(window.matchMedia('(max-width: 770px)').matches) {
            await showSideBar(false)
        }

        if (isDisabled) e.preventDefault()
    }

    return (
        <NavigationMenu
            to={item?.path}
            //className={({ isActive }) => `default-menu ${isActive && 'active-menu'}`}
            onClick={(e) => {
                if (item.title === 'Cbp'){
                    setInfoProperty('cbp', true)
                    // sessionStorage.setItem('cbpState', JSON.stringify(true))
                }else {
                    setInfoProperty('cbp', false);
                }
                handleSideBarShow(e)
            }}
            isdisabled={isDisabled}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(item.path.includes(location.pathname))}
        >
            <GridContainer bottomMargin="0.4" >
                <SideBarIcons>{item.icon(isHover)}</SideBarIcons>
                <SideBarLabel>{item.title}</SideBarLabel>
            </GridContainer>
        </NavigationMenu>
    )
}